import { ContentIntro } from './content/intro';
import { InternQuestion } from './intern/question';

/**
 * Model definition for FAQ
 */
export interface FAQ {
  __contentType: 'faq';
  id: string;
  name?: string;
  activateStructuredData?: boolean;
  displayNumbers?: boolean;
  intro?: ContentIntro;
  questions: InternQuestion[];
}

export function isFAQ(obj: { __contentType?: string }): obj is FAQ {
  return obj.__contentType === 'faq';
}
